export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3772511.09391059.jpg";